module.exports = __webpack_public_path__ + "images/bg-cash-coupon-f39de880b2bba575ab8049b2db06d6c2.png";